export default "__VITE_ASSET__2a60bfd4__"